import * as squint_core from 'squint-cljs/core.js';
var query = /* @__PURE__ */ (() => {
let f11317_1 = null;
const impl11320_2 = (function (q, el) {
if (squint_core.truth_(el)) {
return el.querySelector(q);
};

});
const impl11321_3 = (function (q) {
return query(q, document);

});
f11317_1 = (function (...args11318) {
const self11322_4 = this;
const G__11323_5 = args11318.length;
switch (G__11323_5) {case 2:
return impl11320_2.call(self11322_4, args11318[0], args11318[1]);

break;
case 1:
return impl11321_3.call(self11322_4, args11318[0]);

break;
default:
throw (new Error(`${"Invalid arity: "}${args11318.length??''}`))};

});
return f11317_1;

})();
var query_all = /* @__PURE__ */ (() => {
let f11324_1 = null;
const impl11327_2 = (function (q, el) {
if (squint_core.truth_(el)) {
return el.querySelectorAll(q);
};

});
const impl11328_3 = (function (q) {
return query_all(q, document);

});
f11324_1 = (function (...args11325) {
const self11329_4 = this;
const G__11330_5 = args11325.length;
switch (G__11330_5) {case 2:
return impl11327_2.call(self11329_4, args11325[0], args11325[1]);

break;
case 1:
return impl11328_3.call(self11329_4, args11325[0]);

break;
default:
throw (new Error(`${"Invalid arity: "}${args11325.length??''}`))};

});
return f11324_1;

})();
var remove_class = function (el, c) {
return el.classList.remove(c);

};
var replace_class = function (el, old, new$) {
return el.classList.replace(old, new$);

};
var add_class = function (el, c) {
return el.classList.add(c);

};
var has_class_QMARK_ = function (el, c) {
return el.classList.contains(c);

};
var toggle_class = function (el, c) {
return el.classList.toggle(c);

};

export { replace_class, toggle_class, query, add_class, has_class_QMARK_, query_all, remove_class }
